import styled, { css } from "styled-components"
import { fieldStyles } from "../../forms/styles"

const sharedStyles = css`
  ${fieldStyles}
  line-height: 22px;

  background-color: ${({ theme }) => theme.colors.lightGrey};
  border-color: ${({ theme }) => theme.colors.lightGrey};
  margin: 0;

  min-height: 3.125rem;
  max-height: 8rem;

  grid-area: 1 / 1 / 2 / 2;
`

export const TextAreaWrapper = styled.div`
  display: grid;

  &:after {
    content: attr(data-replicated-value) " ";
    white-space: pre-wrap;
    visibility: hidden;
    ${sharedStyles}
  }
`

export const TextArea = styled.textarea`
  resize: none;
  overflow: hidden;
  overflow-y: auto;
  ${sharedStyles}

  &::-webkit-scrollbar {
    width: 0.25rem;
    overflow: hidden;
  }

  &::-webkit-scrollbar-track {
    margin: 0.5rem;
    background-color: ${({ theme }) => theme.colors.lightGrey};
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d8d8d8;
    border-radius: 0.125rem;
  }
`
